import React from 'react';
import { Button, useColorModeValue } from '@cardboard-ui/react';

interface FloatingToolbarMenuItemProps {
  icon: React.ReactElement;
  title: string;
  onClick: () => void;
  selected?: boolean;
}

export function FloatingToolbarMenuItem({
  icon,
  title,
  onClick,
  selected = false,
}: FloatingToolbarMenuItemProps) {
  const selectedBgColor = useColorModeValue(
    selected ? 'gray.200' : undefined,
    selected ? 'gray.600' : undefined,
  );

  return (
    <Button
      leftIcon={icon}
      onClick={onClick}
      bgColor={selectedBgColor}
      variant="ghost"
      size="xs"
    >
      {title}
    </Button>
  );
}
